export default "__VITE_ASSET__0367b7db__"